module.exports = __webpack_public_path__ + "static/media/Entomological Society of America Logo New.96450c0e.jpg";